import { useGetBookings } from 'api-hooks/booking/query';
import Stack from 'components/commons/stack';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { Skeleton } from 'components/widgets/skeleton';
import useMappingBookingItems from 'hooks/use-mapping-booking-items';
import * as React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Oval } from 'react-loader-spinner';
import color from 'styles/color';
import { useDebouncedCallback } from 'use-debounce';

import CheckBookingCard from './check-booking-card';
import BookingEmptyView from './empty-view';

interface BookingTemplateProps {
  type: 'active' | 'history' | 'pending' | 'refund';
}

export function Loading() {
  return (
    <Skeleton
      style={{
        borderRadius: 4,
        height: 200,
      }}
    />
  );
}

export default function BookingTemplate(props: BookingTemplateProps) {
  const { type } = props;
  const { data, error, isLoading, hasNextPage, fetchNextPage } = useGetBookings(
    {
      params: {
        type,
      },
    },
  );
  const debounceBooking = useDebouncedCallback(fetchNextPage, 2000);

  const bookings = useMappingBookingItems(
    (data?.pages || []).map((page) => page.data).flat(),
    type,
  );

  const isEmpty = bookings.length === 0;

  return (
    <FetchWrapperComponent
      error={error}
      isLoading={isLoading}
      loadingComponent={
        <Stack gap="sm">
          <Loading />
          <Loading />
          <Loading />
        </Stack>
      }
      component={
        <InfiniteScroll
          loadMore={() => debounceBooking()}
          hasMore={hasNextPage}
          loader={
            <Stack alignItems="center">
              <Oval
                color={color.primary}
                secondaryColor={color.primary5}
                width={24}
                height={24}
              />
            </Stack>
          }
        >
          {isEmpty && <BookingEmptyView type={type} />}
          {bookings.map((booking) => {
            return <CheckBookingCard {...booking} key={booking.id} />;
          })}
        </InfiniteScroll>
      }
    />
  );
}
